import classnames from 'classnames';
import React from 'react';

interface TableCellProps {
	children?: React.ReactNode | string | number;
	className?: string;
	colSpan?: number;
	cellsNum?: number;
	isTableHead?: boolean;
	align?: 'left' | 'center' | 'right' | 'justify';
	style?: React.CSSProperties;
}

const TableCell: React.FC<TableCellProps> = ({
	children,
	className = '',
	colSpan = 1,
	cellsNum = 0,
	isTableHead = false,
	align = 'left',
	style = null,
}) => {
	const classes = {
		align: {
			left: 'text-left',
			center: 'text-center',
			right: 'text-right',
			justify: 'text-justify',
		},
		isTableHead: {
			true: '',
			false: 'border-r border-secondary-light',
		},
	};

	return (
		<div
			className={classnames(
				'break-all px-2 last:border-r-0',
				`w-${colSpan}/${cellsNum}`,
				classes.align[align],
				classes.isTableHead[isTableHead.toString()],
				className,
			)}
			style={style}
		>
			{children}
		</div>
	);
};

export default TableCell;
